/**
 * Google Automated Discounts (GAD) Handler
 * Decodes JWT tokens from pv2 URL parameter and displays Google-provided prices
 */
window.GAD = {
  MERCHANT_ID: '291895225',
  STORAGE_KEY: 'gad_session',

  // Decode JWT without cryptographic verification
  // JWT payload is Base64URL encoded
  decodeToken: function(token) {
    try {
      var parts = token.split('.');
      if (parts.length !== 3) return null;
      // Base64URL to Base64 conversion
      var base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      // Pad if necessary
      while (base64.length % 4) {
        base64 += '=';
      }
      var payload = JSON.parse(atob(base64));
      return payload;
    } catch (e) {
      console.warn('GAD: Failed to decode token', e);
      return null;
    }
  },

  // Check URL for pv2 parameter
  getTokenFromURL: function() {
    var params = new URLSearchParams(window.location.search);
    return params.get('pv2');
  },

  // Store GAD price in localStorage (48 hour expiry, persists across sessions)
  // Stored globally (not per-product) so it works across all pages
  storePrice: function(offerId, price, currency, priorPrice, tokenExp, discountCode) {
    var data = {
      offerId: offerId,
      price: price,
      currency: currency,
      priorPrice: priorPrice,
      timestamp: Date.now(),
      expiry: Date.now() + (48 * 60 * 60 * 1000), // 48 hours
      tokenExp: tokenExp, // Original token expiry timestamp
      discountCode: discountCode // Google's discount code for checkout
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
  },

  // Retrieve stored GAD session if not expired (global, not per-product)
  getStoredPrice: function() {
    var stored = localStorage.getItem(this.STORAGE_KEY);
    if (!stored) return null;
    try {
      var data = JSON.parse(stored);
      var now = Date.now();
      // Check both storage expiry (48h) and original token expiry
      if (now > data.expiry || (data.tokenExp && now > data.tokenExp * 1000)) {
        localStorage.removeItem(this.STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  },

  // Check if token is expired - strict check per Google requirements
  // Only apply discount if exp is in the future
  isExpired: function(payload) {
    if (!payload.exp) return true; // Tokens must have expiry
    var expTime = payload.exp * 1000;
    var now = Date.now();
    var graceMs = 60 * 1000; // 60 seconds clock skew tolerance only
    var expired = expTime + graceMs < now;
    if (expired) {
      console.log('GAD: Token exp:', new Date(expTime).toISOString(), 'Now:', new Date(now).toISOString());
    }
    return expired;
  },

  // Apply discount code to Shopify cart via official API
  // This persists through all checkout methods (Buy Now, Apple Pay, Shop Pay, etc.)
  applyDiscountToCart: function(discountCode) {
    if (!discountCode) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountCode })
    }).then(function(response) {
      if (response.ok) {
        console.log('GAD: Discount code applied to cart:', discountCode);
      }
      return response;
    }).catch(function(err) {
      console.warn('GAD: Failed to apply discount to cart:', err);
    });
  },

  // Main initialization - checks for token in URL or retrieves stored session
  init: function() {
    var token = this.getTokenFromURL();
    console.log('GAD: Checking for token, found:', token ? 'yes' : 'no');
    if (token) {
      var payload = this.decodeToken(token);
      console.log('GAD: Decoded payload:', payload);
      if (payload) {
        // Validate merchant ID (compare as strings)
        if (String(payload.m) !== String(this.MERCHANT_ID)) {
          console.warn('GAD: Merchant ID mismatch. Token:', payload.m, 'Expected:', this.MERCHANT_ID);
          return null;
        }
        // Check expiration
        if (this.isExpired(payload)) {
          console.warn('GAD: Token expired');
          return null;
        }
        // Store and return the price
        console.log('GAD: Valid token, applying price:', payload.p);
        this.storePrice(payload.o, payload.p, payload.c, payload.pp, payload.exp, payload.dc);
        // Set discount code cookie for checkout (48 hour expiry)
        if (payload.dc) {
          document.cookie = "discount_code=" + payload.dc + "; max-age=172800; path=/";
          console.log('GAD: Set discount code cookie:', payload.dc);
        }
        return {
          offerId: payload.o,
          price: payload.p,
          priorPrice: payload.pp,
          currency: payload.c,
          discountCode: payload.dc
        };
      }
    }
    // Check for stored GAD session (works on any page - cart, product, etc.)
    return this.getStoredPrice();
  }
};

// GAD Price display function - matches discount code styling exactly
window.applyGADPrice = function(gadPrice) {
  var elements = 'div[data-section-id=product-template] .product-price, div[data-section-id=collection-template] .product-price, #shopify-section-product-recommendations .product-price, #your-shopping-cart .quickadd .product-price';
  var tagSvg = '<svg style="height: 20px;width: 20px;vertical-align: middle;" id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg>';

  $(elements).not('[data-gad_applied]').each(function() {
    var $this = $(this);

    var newPrice = parseFloat(gadPrice.price).toFixed(2);

    // Get prior price from token, or fall back to current page price
    var priorPrice = gadPrice.priorPrice ? parseFloat(gadPrice.priorPrice).toFixed(2) : null;
    if (!priorPrice) {
      // Extract current price from the page element (same method as discount code system)
      var currentText = $this.text().replace(/^\D+/g, '');
      if (currentText) {
        priorPrice = parseFloat(currentText).toFixed(2);
      }
    }

    // Only show discount if we have both prices and GAD price is lower
    if (priorPrice && parseFloat(newPrice) < parseFloat(priorPrice)) {
      // Price display - exact same format as discount_string() in theme.js
      var html = '<span style="margin-right=0.8em;"><strong>£' + newPrice + '&ensp;</strong></span> <strike>£' + priorPrice + '</strike>';

      // Add empty discount wrapper (same as discount code system)
      if ($this.hasClass('product-price--large')) {
        html += '<div class="discount-wrapper"></div>';
      }

      $this.html(html);
      $this.attr('data-discount_pricebefore', priorPrice);
      $this.attr('data-gad_applied', 'true');
    }
  });

  // Populate discount wrapper with banner (same as discount code system)
  $(elements).each(function() {
    var $this = $(this);
    var priorPrice = $this.attr('data-discount_pricebefore');
    if (priorPrice && gadPrice.price) {
      var prior = parseFloat(priorPrice);
      var newP = parseFloat(gadPrice.price);
      var savingsPercent = Math.ceil(((prior - newP) / prior) * 100);
      if (savingsPercent > 0) {
        $this.find('.discount-wrapper').html(tagSvg + ' <span>You\'ve saved an extra <strong>' + savingsPercent + '%</strong> using Google Shopping</span>');
      }
    }
  });
};
